import React from "react";
import { DialogContent, List, ListItem, ListItemText, Typography, makeStyles, Theme } from "@material-ui/core";
import moment from "moment";
import { Tournament } from "types/tournament";
import StandardDialog from "../SharedComponents/StandardDialog";
import DialogToolbar from "../SharedComponents/DialogToolbar";

interface Props {
  open: boolean;
  tournaments: Tournament[];
  onClose(): void;
  onSelect(tournament: Tournament): void;
}

export default function LinkedTournamentsPicker({ open, tournaments, onClose, onSelect }: Props) {
  const classes = useStyles();

  return (
    <StandardDialog open={open} onClose={onClose} scroll="paper">
      <DialogToolbar title="Tournament leaderboards" onClick={onClose} titleId="linked-tournaments-title" />
      <DialogContent className={classes.content}>
        <Typography variant="body2" color="textSecondary" className={classes.hint}>
          This game is linked to more than one tournament. Choose which standings to view.
        </Typography>
        <List disablePadding className={classes.list}>
          {tournaments.map(tournament => (
            <ListItem
              key={tournament._id}
              button
              className={classes.item}
              onClick={() => onSelect(tournament)}
            >
              <ListItemText
                primary={tournament.name}
                secondary={`${moment(tournament.seasonStart).format("ll")} – ${moment(tournament.seasonEnd).format("ll")}`}
                primaryTypographyProps={{ className: classes.itemPrimary }}
                secondaryTypographyProps={{ className: classes.itemSecondary }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </StandardDialog>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    paddingTop: 0,
    paddingBottom: theme.spacing(2),
  },
  hint: {
    marginBottom: theme.spacing(1),
    lineHeight: 1.45,
    fontSize: "0.8125rem",
  },
  list: {
    borderTop: `1px solid rgba(226, 232, 240, 0.95)`,
  },
  item: {
    borderBottom: `1px solid rgba(226, 232, 240, 0.95)`,
    paddingTop: theme.spacing(1.25),
    paddingBottom: theme.spacing(1.25),
    "&:active": {
      backgroundColor: "rgba(248, 250, 252, 1)",
    },
  },
  itemPrimary: {
    fontWeight: 600,
    color: "#0f172a",
    fontSize: "0.9375rem",
  },
  itemSecondary: {
    fontSize: "0.75rem",
    color: "#64748b",
  },
}));
